export default {
  _not_interested_in_this_video: 'Sie interessieren sich nicht für dieses Video? %second%',
  _switch_one: 'Ein weiterer',
}